module.exports = __webpack_public_path__ + "static/media/software-1.660ccaeb.jpg";